import { useState } from "react";
import { Button, Layout, Flex, Card, Space, Typography, Input } from "antd";

import PageLayout from "../../components/common/Layouts/PageLayout";
import HelmetWrapper from "../../components/common/Layouts/HelmetWrapper";
import { FilterIcon, SearchIcon } from "../../assets/CustomIcon";

import t1 from "../../assets/images/template1.jpg";
import t2 from "../../assets/images/template2.jpg";
import t3 from "../../assets/images/template3.jpg";
import t4 from "../../assets/images/template4.jpg";
import t5 from "../../assets/images/template5.jpg";
import t6 from "../../assets/images/template6.jpg";
import t7 from "../../assets/images/template7.jpg";

const { Content } = Layout;
const { Title } = Typography;

const categories = [
  "All",
  "Birthday",
  "Engagement",
  "Wedding",
  "Yoga Class",
  "Halloween",
  "New Year Eve",
];

const templates = [
  { id: 1, img: t1, category: "Birthday" },
  { id: 2, img: t2, category: "Engagement" },
  { id: 3, img: t3, category: "Halloween" },
  { id: 4, img: t4, category: "New Year Eve" },
  { id: 5, img: t5, category: "Yoga Class" },
  { id: 6, img: t6, category: "Wedding" },
  { id: 7, img: t7, category: "Birthday" },
];

export default function TemplatesPage() {
  const [activeCategory, setActiveCategory] = useState("All");
  const [selected, setSelected] = useState(null);
  const [isFiltering, setIsFiltering] = useState(false);

  const handleCategoryChange = (cat) => {
    setIsFiltering(true);
    setActiveCategory(cat);

    // must match CSS animation duration
    setTimeout(() => {
      setIsFiltering(false);
    }, 250);
  };

  const filteredTemplates =
    activeCategory === "All"
      ? templates
      : templates.filter((item) => item.category === activeCategory);

  return (
    <PageLayout title="Templates">
      {/* SEO HELMET WRAPPER */}
      <HelmetWrapper
          title="Pinginvite - The Go-To Platform for Local Events in Kolkata & Dubai" 
          description="Pingvite connects people with local events in Kolkata and Dubai through community focus, affordability, 
          and city-specific visibility for organizers and users." 
          keywords="Top Upcoming Events in Kolkata, Best Live Events in Kolkata, best upcoming events in Kolkata, 
          online events near you in Kolkata,  upcoming events in Kolkata, Events in Kolkata, Top Upcoming Events in Dubai, 
          Best Live Events in Dubai, best upcoming events in Dubai, online events near you in Dubai, Event calendar in Dubai, 
          Event tickets in Dubai, upcoming events in Dubai, Events in Dubai"
      />
      <Content>
        <div className="templatePage">
          {/* Header + Search */}
          <Flex align="center" className="templateFilterSec" gap={12}>
            <Title level={4} className="filterTitleText">
              Select Template
            </Title>

            <Input
              prefix={<SearchIcon />}
              placeholder="Search Templates..."
              className="searchInput"
              size="large"
            />

            <Button
              icon={<FilterIcon />}
              type="text"
              className="filterIconBtn"
            />
          </Flex>

          {/* Categories */}
          <Space wrap className="categoryRow">
            {categories.map((cat) => (
              <Button
                key={cat}
                className={`categoryBtn ${
                  activeCategory === cat ? "active" : ""
                }`}
                onClick={() => handleCategoryChange(cat)}
              >
                {cat}
              </Button>
            ))}
          </Space>

          {/* Masonry Grid */}
          <div className={`masonryGrid ${isFiltering ? "filtering" : ""}`}>
            {filteredTemplates.map((item) => (
              <Card
                key={item.id}
                hoverable
                className={`masonryItem ${
                  selected === item.id ? "selected" : ""
                }`}
                cover={<img src={item.img} alt="template" />}
                styles={{ body: { display: "none" } }}
                onClick={() => setSelected(item.id)}
              />
            ))}
          </div>
        </div>
      </Content>
    </PageLayout>
  );
}
